import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, DropdownCard, type ITabItem, Tabs } from 'shared/ui'
import {
  addContactNoteTemplate,
  addConversationNoteTemplate,
  addTagTemplate,
  handoffToHumanTemplate,
  removeTagTemplate,
  sendSMSTemplate,
} from 'entities/TemplateActions/actions.tsx'
import { addTag } from 'widgets/TemplateActions/addTag'
import { removeTag } from 'widgets/TemplateActions/removeTag'
import { handoffToHuman } from 'widgets/TemplateActions/handoffToHuman'
import { MergeField } from 'widgets/MergeField'
import { addContactNote } from 'widgets/TemplateActions/addContactNote'
import { addConversationNote } from 'widgets/TemplateActions/addConversationNote'
import type { AgentInstructionsStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/store/AgentInstructionsStore.tsx'
import { callingAgentSendSMS } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/actions/sendSMS/callingAgentSendSMS.tsx'

export const ShortcutContent = observer(
  ({ store, onClose }: { store: AgentInstructionsStore; onClose: () => void }) => {
    const {
      entities,
      onChooseMergeField,
      mergeFieldConfig,
      onAddHandoffToHumanAction,
      onAddSMSAction,
      onAddTagAction,
      onRemoveTagAction,
      onAddContactNoteAction,
      onAddConversationNoteAction,
    } = store

    const [activeTabKey, setActiveTabKey] = useState<'merge_fields' | 'actions'>('merge_fields')

    const tabs: ITabItem<typeof activeTabKey>[] = [
      { key: 'merge_fields', name: 'Merge fields' },
      {
        key: 'actions',
        name: 'Actions',
      },
    ]

    const handleDropdownCardClick = (cb: () => void) => () => {
      onClose()
      cb()
    }

    return (
      <Box width={'280px'}>
        <Tabs
          uiClasses={['fullDivider', 'p8']}
          activeTabKey={activeTabKey}
          handleSelectTab={(tab) => setActiveTabKey(tab.key)}
          tabs={tabs}
        />
        {activeTabKey === 'merge_fields' && (
          <MergeField
            onCloseMenu={onClose}
            isNoAutoFocus
            onAddMergeField={(field) => onChooseMergeField(field, '/')}
            isFullWidth
            {...mergeFieldConfig}
          />
        )}
        {activeTabKey === 'actions' && (
          <Box padding={0.5}>
            <DropdownCard
              item={{
                ...addTagTemplate.dropdownItem,
                onClick: handleDropdownCardClick(() => addTag({ onSave: onAddTagAction })),
              }}
            />
            <DropdownCard
              item={{
                ...removeTagTemplate.dropdownItem,
                onClick: handleDropdownCardClick(() => removeTag({ onSave: onRemoveTagAction })),
              }}
            />
            <DropdownCard
              item={{
                ...addContactNoteTemplate.dropdownItem,
                onClick: handleDropdownCardClick(() =>
                  addContactNote(
                    {
                      onSave: onAddContactNoteAction,
                    },
                    entities
                  )
                ),
              }}
            />
            <DropdownCard
              item={{
                ...addConversationNoteTemplate.dropdownItem,
                onClick: handleDropdownCardClick(() =>
                  addConversationNote(
                    {
                      onSave: onAddConversationNoteAction,
                    },
                    entities
                  )
                ),
              }}
            />
            <DropdownCard
              item={{
                ...sendSMSTemplate.dropdownItem,
                onClick: handleDropdownCardClick(() =>
                  callingAgentSendSMS({ onSave: onAddSMSAction })
                ),
              }}
            />
            <DropdownCard
              item={{
                ...handoffToHumanTemplate.dropdownItem,
                onClick: handleDropdownCardClick(() =>
                  handoffToHuman({ onSave: onAddHandoffToHumanAction })
                ),
              }}
            />
          </Box>
        )}
      </Box>
    )
  }
)
